import { stats } from "@/mocks/narutoData";
import SectionHeading from "./SectionHeading";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <SectionHeading
              align="left"
              eyebrow="关于本站"
              title="一座为同人读者打造的导航灯塔"
              desc="火影忍者同人官网致力于整理散落各平台的火影同人佳作，让好故事不再被埋没。"
            />

            <div className="-mt-2 flex flex-col gap-4 text-sm leading-relaxed text-foreground-600">
              <p>
                我们相信，每一部同人都是对火影世界的一次深情解读。因此我们长期跟踪各大同人平台，
                按角色、CP、题材与热度反复筛选，只把真正值得读的优质作品纳入导航目录。
              </p>
              <p>
                无论你想重温第七班的日常温情，还是探寻宇智波一族悲壮的过去，这里都有对应的专题合集，
                帮你省去大海捞针的寻找时间。
              </p>
              <div className="mt-2 grid grid-cols-2 sm:grid-cols-4 gap-3">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-lg border border-background-200 bg-background-100 p-3">
                    <div className="font-heading text-lg md:text-xl font-bold text-primary-500">{s.value}</div>
                    <div className="mt-1 text-xs text-foreground-600">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-lg border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20anime%20illustration%20of%20an%20old%20ninja%20library%20filled%20with%20scrolls%20books%20and%20lit%20lanterns%2C%20a%20reading%20desk%20with%20open%20scrolls%2C%20cozy%20warm%20glow%2C%20orange%20and%20gold%20accents%2C%20atmospheric%20depth%2C%20high%20detail%20anime%20art&width=1000&height=760&seq=about-img&orientation=portrait"
              alt="火影忍者同人作品整理的阅览室与卷轴书架"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}